import { get, post } from 'apis';
import NotificationRoutes from './Notification.Routes';

const NotificationServices = {
  getNotifications: async (params) => {
    const data = await get(NotificationRoutes.getNotifications, params);
    return data;
  },
  markAsRead: async (obj) => {
    const data = await post(NotificationRoutes.markAsRead, obj);
    return data;
  },
}

export default NotificationServices